module.exports = __webpack_public_path__ + "img/20190711165013YY截图20190711014148.9ea3ff47.png";